import {areArraysTheSame} from "../../../../utils/Functions";

export function resetUserPermissions(setUsersPermissions, userPermissions) {
  setUsersPermissions(userPermissions);
}

export function isButtonDisabled(user, array1, array2,hasPermission) {
  return areArraysTheSame(array1, array2);
}
